import { Controller } from "@hotwired/stimulus";
import { patch, post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["star"]
  connect(){

  }

  rate(e){
    post(
      this.element.dataset.url,
      {
        body: { rate: e.target.dataset.level },
        contentType: "application/json",
        responseKind: "json",
      }
    );
    this.element.classList.add('rated')
  }
}
